<template>
  <div class="page page-wide" id="page-campaign">
    <Metadata
      :title="this.title"
    />
    <NavLeft
      v-bind:advertiserLabel="this.advertiser.label"
      v-bind:advertiserReportingLabel="this.advertiser.reportingLabel"
      v-bind:campaigns="this.campaigns"
    />
    <div class="content-wrapper">
      <div class="content" id="content-campaign">
        <div class="page-heading">
          <div class="breadcrumbs_container">
            <router-link
              class="breadcrumbs-previous"
              :to="{ name: 'campaigns', params: {advertiserLabel: this.advertiser.label}}"
            >
              <span v-if="this.advertiser.reportingLabel && this.advertiser.reportingLabel !== ''">
                {{this.advertiser.reportingLabel}}
              </span>
              <span v-else>
                {{this.advertiser.label}}
              </span>
            </router-link>
            <span class="breadcrumbs-last">Campaigns</span>
          </div>
          <h1 class="heading-h1" v-if="this.campaign.reportingLabel && this.campaign.reportingLabel !== ''">
            {{this.campaign.reportingLabel}}
          </h1>
          <h1 class="heading-h1" v-else>
            {{this.campaign.label}}
          </h1>
        </div>
        <Loader />
        <Detail
          v-bind:label="this.campaign.label"
          v-bind:embedUrl="campaign['embed.url']['overview']"
          type="campaign"
        />
      </div>
    </div>
  </div>
</template>

<script>

import Top from '../components/nav/Top.vue';
import NavLeft from '../components/nav/LeftCampaigns.vue';
import Bottom from '../components/nav/Bottom.vue';

import Detail from '../components/Detail.vue';
import Loader from '../components/Loader.vue';

export default {
  name: 'campaign',
  components: {
    Top,
    NavLeft,
    Bottom,
    Detail,
    Loader,
  },
  watch: {
    '$route.params.campaignLabel': function () {
      const { campaignLabel } = this.$route.params;
      this.campaign = this.campaigns.find(campaign => campaign.label === campaignLabel);
      this.title = `reporting - ${this.campaign.label}`;
    },
  },
  created() {
    const { advertiserLabel } = this.$route.params;
    this.advertiser = this.$store.state.advertisers
      .find(advertiser => advertiser.label === advertiserLabel);
    this.campaigns = this.advertiser.campaigns;
    const { campaignLabel } = this.$route.params;
    this.campaign = this.campaigns.find(campaign => campaign.label === campaignLabel);
    this.title = `reporting - ${this.campaign.label}`;
    setTimeout(() => {
      document.getElementById('campaign-iframe_wrapper').classList.add('active');
    }, 4000);
  },
  data() {
    return {
      title: null,
      advertiser: null,
      campaigns: null,
      campaign: null,
    };
  },
};
</script>

<style>
#content-campaign {
  overflow-y: hidden;
}
</style>
